// src/utils/reconstructJson.ts

import { FlattenedTranslation } from "./flattenJson";
import { Translations } from "./loadTranslations";

export const reconstructTranslations = (
	data: FlattenedTranslation[],
	languages: string[]
      ): Translations => {
	const reconstructed: Translations = {};
      
	for (const language of languages) {
	  reconstructed[language] = {};
	}
      
	data.forEach((item) => {
	  languages.forEach((language) => {
	    const value = item.translations[language];
	    if (value !== undefined) {
	      const keys = item.key.split('.');
	      const fileName = keys[0];
	      const restKeys = keys.slice(1);
      
	      if (!reconstructed[language][fileName]) {
		reconstructed[language][fileName] = {};
	      }
	      setNestedValue(reconstructed[language][fileName], restKeys, value);
	    }
	  });
	});
      
	return reconstructed;
      };
      
      const setNestedValue = (obj: any, keys: string[], value: any) => {
	let current = obj;
	keys.forEach((key, index) => {
	  if (index === keys.length - 1) {
	    current[key] = value;
	  } else {
	    if (!current[key] || typeof current[key] !== 'object') {
	      current[key] = {};
	    }
	    current = current[key];
	  }
	});
      };
      